"use client";
import { lighten, useComputedColorScheme, useMantineTheme } from "@mantine/core";
import BottomWave from "../../../../public/static/images/bottomwave.svg";

export default function WaveBanner({
  subjectNameLower,
  colors,
  bgColor,
  marginTop,
  flip,
  mirror,
}: {
  subjectNameLower?: string;
  colors?: { light: string; dark: string };
  bgColor?: string;
  marginTop?: string;
  flip?: true;
  mirror?: true;
}) {
  const theme = useMantineTheme();
  const colorScheme = useComputedColorScheme("light");
  return (
    <BottomWave
      style={{
        display: "block",
        maxWidth: "100%",
        transform: `${flip ? "rotate(180deg)" : ""} ${
          mirror ? "scaleX(-1)" : ""
        }`,
        marginTop: marginTop,
        backgroundColor: bgColor,
      }}
      fill={
        subjectNameLower
          ? colorScheme === "light"
            ? lighten(theme.colors.gray[0], 0.2)
            : theme.colors.dark[8]
          : colors
          ? colorScheme === "light"
            ? colors.light
            : colors.dark
          : colorScheme === "light"
          ? theme.colors.darkblue[6]
          : theme.colors.dark[8]
      }
    />
  );
}
